import React from 'react';
import callApi from '../../call-api';

export default class Fetch extends React.Component {
  state = {
    data: null,
    pending: true,
    error: false,
  };
  componentDidMount() {
    callApi(this.props.url, this.props.options, {
      normalize: this.props.normalize,
    }).then(
      ({ json }) => {
        this.setState({ pending: false, data: json });
      },
      () => {
        this.setState({ pending: false, error: true });
      }
    );
  }

  render() {
    return this.props.children(this.state);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Fetch/index.js